import { services } from '../services';
var action = "report/";

export const dailyReportService = {
    getNotification,
    getCustomerFollowUp
};



function getNotification(param = '', uri='daily-notification') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getCustomerFollowUp(param = '', uri='daily-customer-follow-up') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

